import { render, staticRenderFns } from "./FarmVehicleTypeActions.vue?vue&type=template&id=23ab846a&scoped=true&"
import script from "./FarmVehicleTypeActions.vue?vue&type=script&lang=ts&"
export * from "./FarmVehicleTypeActions.vue?vue&type=script&lang=ts&"
import style0 from "./FarmVehicleTypeActions.vue?vue&type=style&index=0&id=23ab846a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab846a",
  null
  
)

export default component.exports